import React, { useState } from 'react';
import { Alert } from 'xm-spark';
import OnboardingLayout from 'components/OnboardingLayout';
import { useGlobalState } from 'hooks/useGlobalState';
import { signupStatus } from 'utils/constants';

import OnboardingForm from './components/OnboardingForm';
import styles from './Onboarding.module.scss';

import { getOnboardingContent } from '../Signup/util';

export default function Onboarding() {
  const [{ signup }] = useGlobalState();
  const [apiError, setApiError] = useState(null);

  const curTemplate = getOnboardingContent();

  return (
    <OnboardingLayout
      promptEnabled={[signupStatus.started, signupStatus.pending].includes(
        signup.status,
      )}
    >
      {apiError && (
        <Alert
          error
          role="alert"
          className={styles.alertBox}
          data-testid="onboarding_alert"
        >
          <span>{apiError}</span>
        </Alert>
      )}
      <h1 className={styles.h1}>{curTemplate.title}</h1>
      <h2 className={styles.h2}>{curTemplate.subtitle}</h2>
      <OnboardingForm signupData={signup.data} setApiError={setApiError} />
    </OnboardingLayout>
  );
}
